// src/components/WardenMessage.jsx
import wardenImg from "../assets/images/WhatsApp Image 2025-07-19 at 08.42.19_12c96a35.jpg"; // ✅ Ensure path is correct

export default function WardenMessage() {
  return (
    <section
      id="warden"
      className="bg-gradient-to-b from-yellow-50 to-white py-16 px-6 sm:px-8 md:px-10"
      aria-label="Message from the Warden"
    >
      <div className="max-w-6xl mx-auto flex flex-col-reverse md:flex-row items-center gap-10">
        {/* Left: Text Content */}
        <div className="w-full md:w-2/3 text-center md:text-left animate-fade-in-up">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-maroon mb-4 sm:mb-6">
            Message from the Warden
          </h2>
          <p className="text-gray-700 text-base sm:text-lg leading-relaxed bg-white/70 rounded-2xl shadow p-4">
            "As the warden of BCWD Surathkal Hostel, I feel honored to guide and
            support a vibrant group of 130 students. Since our beginning in 2002,
            we’ve nurtured talent and discipline in a safe and culturally rich
            environment. We believe in creating a space where every student
            feels at home while pursuing excellence in their education."
          </p>
          <p className="mt-4 sm:mt-6 text-maroon font-semibold text-base sm:text-lg">
            – SRI RADHESH (MA., M.Ed., MPhil), Warden
          </p>
        </div>

        {/* Right: Circular Image with Glow + Hover Effects */}
        <div className="w-48 h-48 sm:w-56 sm:h-56 md:w-72 md:h-72 relative group rounded-full shadow-xl border-4 border-maroon overflow-hidden">
          <img
            src={wardenImg}
            alt="Warden"
            className="w-full h-full object-cover rounded-full group-hover:scale-110 group-hover:brightness-110 transition-all duration-500"
          />
          {/* Glow effect */}
          <div className="absolute inset-0 rounded-full bg-maroon/20 group-hover:bg-maroon/30 transition-all duration-500" />
        </div>
      </div>
    </section>
  );
}
